import { render, staticRenderFns } from "./tigerSelfRestraint.vue?vue&type=template&id=2979697d"
import script from "./tigerSelfRestraint.vue?vue&type=script&lang=js"
export * from "./tigerSelfRestraint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports